<template>
  <div id="section-dropdown">
    <div class="tw-relative tw-flex tw-justify-between tw-items-center">
      <div
        class="tw-flex tw-items-center tw-cursor-pointer"
        @click="showDropdown"
      >
        <div>
          <img
            v-if="title === 'company update'"
            src="@/assets/img/company-update.svg"
            alt="company update icon"
          />
          <img
            v-if="title === 'order book'"
            src="@/assets/img/orderbook-icon.svg"
            alt="order book icon"
          />
        </div>
        <h3 class="tw-text-black-dark2 tw-ml-4 md:tw-ml-">
          <span v-if="openDropdown">Click to collapse</span>
          <span v-if="!openDropdown">Click to expand</span> {{ title }}
        </h3>
      </div>
      <button
        v-if="openDropdown && title === 'company update'"
        class="tw-flex tw-justify-end tw-items-center hover:tw-bg-white"
        @click="$emit('showUpdateForm')"
      >
        <img src="@/assets/img/plus-update.svg" alt="plus" />
        <p class="tw-hidden sm:tw-block tw-text-primary tw-text-sm tw-ml-2">
          Add New Update
        </p>
      </button>
      <img
        v-if="!openDropdown"
        src="@/assets/img/chevron-down.svg"
        alt="order book icon"
      />
      <img
        v-if="openDropdown && title === 'order book'"
        src="@/assets/img/chevron-up.svg"
        alt="order book icon"
      />
    </div>
    <transition
      name="dropdown"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
    >
      <div v-show="openDropdown" class="">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SectionDropdown",

  props: {
    title: { type: String, default: () => "", required: true },
  },

  data() {
    return {
      openDropdown: false,
    };
  },

  methods: {
    showDropdown() {
      this.openDropdown = !this.openDropdown;
    },

    enter(element) {
      element.style.height = "auto";
      let height = getComputedStyle(element).height;
      element.style.height = 0;
      getComputedStyle(element);
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      element.style.height = getComputedStyle(element).height;
      getComputedStyle(element);
      setTimeout(() => {
        element.style.height = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#section-dropdown {
  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: height 0.3s ease-in-out;
    overflow: hidden;
  }
}
</style>
